// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.cdnfonts.com/css/times-new-roman);"]);
// Module
exports.push([module.id, ".mainText{font-family:Times New Roman,sans-serif!important}.text-danger>h5,.text-danger>label{color:red}", ""]);
// Exports
module.exports = exports;
